export default {
    BASE_URL: '/admin/crm/mem/cert/receive/',
    api: [
        {
            name: 'list',
            desc: '列表',
            method: 'GET',
            path: '/overview'
        },
        {
            name: 'take',
            desc: '证书领取',
            method: 'PUT',
            path: '/code'
        },
        {
            name: 'post',
            desc: '邮寄证书',
            method: 'PUT',
            path: '/mail'
        }
    ]
}

  


// WEBPACK FOOTER //
// ./src/api/cert/receive.js